module.exports = __webpack_public_path__ + "static/media/ME.2b8ef821.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/ME.svg
// module id = 2205
// module chunks = 7